import { render } from "./ObsahLinkSegment.vue?vue&type=template&id=2a1a2a1c"
import script from "./ObsahLinkSegment.vue?vue&type=script&lang=js"
export * from "./ObsahLinkSegment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__